var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgEwiChatbotToolClose = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.625 1.04167V15.2083M0.625 5.95833C0.625 4.09167 0.625 3.15833 0.988333 2.445C1.30791 1.81782 1.81782 1.30791 2.445 0.988333C3.15833 0.625 4.09167 0.625 5.95833 0.625H10.2917C12.1583 0.625 13.0917 0.625 13.805 0.988333C14.4322 1.30791 14.9421 1.81782 15.2617 2.445C15.625 3.15833 15.625 4.09167 15.625 5.95833V10.2917C15.625 12.1583 15.625 13.0917 15.2617 13.805C14.9421 14.4322 14.4322 14.9421 13.805 15.2617C13.0917 15.625 12.1583 15.625 10.2917 15.625H5.95833C4.09167 15.625 3.15833 15.625 2.445 15.2617C1.81782 14.9421 1.30791 14.4322 0.988333 13.805C0.625 13.0917 0.625 12.1583 0.625 10.2917V5.95833Z",
    stroke: "#1E1E1E",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgEwiChatbotToolClose);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/EWI_chatbot_tool_close.b321c83f2ae2113077ad4eeced725d22.svg";